import request from './request.js';


//权限相关
export async function addCompany(params = {}) {
    return await request('sys/admin/addCompany', 'post', params);
}

//权限相关
export async function getCompanyList(params = {}) {
    return await request('sys/admin/getCompanyList', 'post', params);
}

//权限相关
export async function updateCompany(params = {}) {
    return await request('sys/admin/updateCompany', 'post', params);
}

//权限相关
export async function getSwitchCompany(params = {}) {
    return await request('sys/admin/getSwitchCompany', 'post', params);
}

//权限相关
export async function getCompanyByUserId(params = {}) {
    return await request('sys/admin/getCompanyByUserId', 'post', params);
}

//权限相关
export async function getRoleMenuIdListByUser(params = {}) {
    return await request('sys/admin/getRoleMenuIdListByUser', 'post', params);
}

//权限相关
export async function saveUserRoleByCompany(params = {}) {
    return await request('sys/admin/saveUserRoleByCompany', 'post', params);
}

//权限相关
export async function getCompanyGroupUserListByCompany(params = {}) {
    return await request('sys/admin/getCompanyGroupUserListByCompany', 'post', params);
}

//权限相关
export async function getRoleListData(params = {}) {
    return await request('sys/admin/getRoleListData', 'post', params);
}

//权限相关
export async function saveRoleMeunFunctionById(params = {}) {
    return await request('sys/admin/saveRoleMeunFunctionById', 'post', params);
}

//权限相关
export async function saveRole(params = {}) {
    return await request('sys/admin/saveRole', 'post', params);
}

//权限相关
export async function saveRoleGroupByType(params = {}) {
    return await request('sys/admin/saveRoleGroupByType', 'post', params);
}

//权限相关
export async function deleteRoleGroupByType(params = {}) {
    return await request('sys/admin/deleteRoleGroupByType', 'post', params);
}

//权限相关
export async function deleteRole(params = {}) {
    return await request('sys/admin/deleteRole', 'post', params);
}

//权限相关
export async function addRole(params = {}) {
    return await request('sys/admin/addRole', 'post', params);
}

//权限相关
export async function getAllCompanyGroup(params = {}) {
    return await request('sys/admin/getAllCompanyGroup', 'post', params);
}

//权限相关
export async function getUserListByRoleByCompany(params = {}) {
    return await request('sys/admin/getUserListByRoleByCompany', 'post', params);
}

//权限相关
export async function getExsitsUserByRole(params = {}) {
    return await request('sys/admin/getExsitsUserByRole', 'post', params);
}

//权限相关
export async function getRoleGroupByCompany(params = {}) {
    return await request('sys/admin/getRoleGroupByCompany', 'post', params);
}

//权限相关
export async function getCompanyListByGroup(params = {}) {
    return await request('sys/admin/getCompanyListByGroup', 'post', params);
}

//权限相关
export async function getMenuIdListByRole(params = {}) {
    return await request('sys/admin/getMenuIdListByRole', 'post', params);
}

//权限相关
export async function getUserListByRole(params = {}) {
    return await request('sys/admin/getUserListByRole', 'post', params);
}

//权限相关
export async function getUserById(params = {}) {
    return await request('sys/admin/getUserById', 'post', params);
}

//权限相关
export async function getUserList(params = {}) {
    return await request('sys/admin/getUserList', 'post', params);
}

//权限相关
export async function saveUser(params = {}) {
    return await request('sys/admin/saveUser', 'post', params);
}

//权限相关
export async function getRoleMenuFunctionList(params = {}) {
    return await request('sys/admin/getRoleMenuFunctionList', 'post', params);
}

//权限相关
export async function deleteUsersByType(params = {}) {
    return await request('sys/admin/deleteUsersByType', 'post', params);
}

//权限相关
export async function deleteUser(params = {}) {
    return await request('sys/admin/deleteUser', 'post', params);
}

//权限相关
export async function updatePasswordHashUser(params = {}) {
    return await request('sys/admin/updatePasswordHashUser', 'post', params);
}

//权限相关
export async function getRoleListByCompany(params = {}) {
    return await request('sys/admin/getRoleListByCompany', 'post', params);
}

//权限相关
export async function getCompanyDataByCurrGroupId(params = {}) {
    return await request('sys/admin/getCompanyDataByCurrGroupId', 'post', params);
}

//权限相关
export async function getUserAndCompanyMapping(params = {}) {
    return await request('sys/admin/getUserAndCompanyMapping', 'post', params);
}

//权限相关
export async function uploadUserExcel(params = {}) {
    return await request('sys/admin/uploadUserExcel', 'post', params);
}

//登录相关
export async function login(params = {}) {
    return await request('sys/login', 'post', params);
}

export async function emailVerifyLogin(params = {}) {
    return await request('sys/emailVerifyLogin', 'post', params);
}

export async function getVerifyCode(params = {}) {
    return await request('sys/verifyCode', 'post', params);
}

export async function getResetPasswordVerifyCode(params = {}) {
    return await request('sys/resetPasswordVerifyCode', 'post', params);
}

export async function resetPassword(params = {}) {
    return await request('sys/resetPassword', 'post', params);
}

// 费用管理页面查询
export async function getFeeCollectionPageList(params = {}) {
    return await request('/fee/collection/feeCollectionPageList', 'post', params);
}

//获取公司列表
export async function getCurrentUserCompany(params = {}) {
    return await request('general/getCurrentUserCompany', 'post', params);
}

// 删除费用批次
export async function deleteFeeCollection(params = {}) {
    return await request('/fee/collection/deleteFeeCollection', 'post', params);
}

// 手动提交主流程
export async function manualSubmitMainProcess(params = {}) {
    return await request('/process/main/manualSubmitMainProcess', 'post', params);
}

// 提交主流程
export async function autoSubmitMainProcess(params = {}) {
    return await request('/process/main/autoSubmitMainProcess', 'post', params);
}

// 合并费用批次
export async function mergeFeeCollection(params = {}) {
    return await request('/fee/collection/mergeFeeCollection', 'post', params);
}

// 自动合并费用批次
export async function autoMergeFeeCollection(params = {}) {
    return await request('/fee/collection/autoMergeFeeCollection', 'post', params);
}


// 根据id获取费用批次信息
export async function getFeeCollectionInfo(params = {}) {
    return await request('/fee/collection/getFeeCollectionInfo', 'post', params);
}

// 更新费用批次信息
export async function updateFeeCollection(params = {}) {
    return await request('/fee/collection/updateFeeCollection', 'post', params);
}

// 根据费用批次id获取费用批次下所有信息
export async function getFeeCollectionBatchInfo(params = {}) {
    return await request('/fee/collection/getFeeCollectionBatchInfo', 'post', params);
}

// 根据id获取发票信息
export async function getInvoiceInfo(params = {}) {
    return await request('/fee/invoice/getFeeInvoiceInfo', 'post', params);
}

//
export async function getFilePath(params = {}) {
    return await request('/fee/invoice/getFilePath', 'post', params);
}

// 新增发票信息
export async function saveFeeInvoice(params = {}) {
    return await request('/fee/invoice/saveFeeInvoice', 'post', params);
}

// 更新发票信息
export async function updateFeeInvoice(params = {}) {
    return await request('/fee/invoice/updateFeeInvoice', 'post', params);
}

// 自主学习
export async function selfStudy(params = {}) {
    return await request('/fee/invoice/selfStudy', 'post', params);
}

// 发票提交查验
export async function inspInvoice(params = {}) {
    return await request('/fee/invoice/insp', 'post', params);
}

// 手工置为查验成功
export async function manualInspSuccess(params = {}) {
    return await request('/fee/invoice/manualInspSuccess', 'post', params);
}

// 删除发票信息
export async function deleteFeeInvoice(params = {}) {
    return await request('/fee/invoice/deleteFeeInvoice', 'post', params);
}

// 删除附件
export async function deleteFile(params = {}) {
    return await request('/fee/invoice/deleteFile', 'post', params);
}

// 拆分费用批次
export async function splitFeeCollection(params = {}) {
    return await request('/fee/collection/splitFeeCollection', 'post', params);
}

//  主流程管理模块
//  主流程页面查询
export async function getMainProcessPageList(params = {}) {
    return await request('/process/main/mainProcessPageList', 'post', params);
}

//  根据barcode获取合成影像路径
export async function getMergeImagePath(params = {}) {
    return await request('/process/main/getMergeImagePath', 'post', params);
}

//  通过操作
export async function passMainProcess(params = {}) {
    return await request('/process/main/passMainProcess', 'post', params);
}

//  作废操作
export async function cancelMainProcess(params = {}) {
    return await request('/process/main/cancelMainProcess', 'post', params);
}

//  撤销操作
export async function undoMainProcess(params = {}) {
    return await request('/process/main/undoMainProcess', 'post', params);
}

//  作废日志页面查询
export async function getProcessCancelLogPageList(params = {}) {
    return await request('/process/main/processCancelLogPageList', 'post', params);
}

//  推送EDI
export async function pushEdi(params = {}) {
    return await request('/process/main/pushEdi', 'post', params);
}

// 影像修复
export async function repairImage(params = {}) {
    return await request('/process/main/repairImage', 'post', params);
}

//  子流程管理模块
//  子流程页面查询
export async function getSubProcessPageList(params = {}) {
    return await request('/process/sub/getSubProcessPageList', 'post', params);
}

//  SAP凭证反写模块
//  SAP凭证反写页面查询
export async function getVoucherReversePageList(params = {}) {
    return await request('/voucher/reverse/getVoucherReversePageList', 'post', params);
}

//  发票认证模块
//  发票认证页面查询
export async function getInvoiceAuthPageList(params = {}) {
    return await request('/invoice/auth/getInvoiceAuthPageList', 'post', params);
}

//  主数据管理模块
//  供应商主数据
export async function getSupplierPageList(params = {}) {
    return await request('/master/supplier/getSupplierPageList', 'post', params);
}

//  PO主数据
export async function getPoManagePageList(params = {}) {
    return await request('/master/po/getPoManagePageList', 'post', params);
}

//  邮件记录页面查询
export async function getMailRecordPageList(params = {}) {
    return await request('/fee/collection/getMailRecordPageList', 'post', params);
}